import styles from './PageProductValuePropositions.module.css';
import valuePropositions from './PageProductValuePropositions.json';
import classNames from 'classnames';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import PageProductValuePropositionsItem from './PageProductValuePropositionsItem.js';
import PageProductValuePropositionsTestimonials from './PageProductValuePropositionsTestimonials.js';
import PageProductValuePropositionsBiographies from './PageProductValuePropositionsBiographies.js';

function PageProductValuePropositions() {
  const { productSku } = useSearchParamOrDefaultProps();
  const valueProposition = valuePropositions.find(
    (valueProposition) => valueProposition.productSku === productSku,
  );
  const { propositions } = valueProposition;

  return (
    <section className={styles.PageProductValuePropositions}>
      <ul className={styles.valuePropositionsList}>
        {propositions.map(
          (
            {
              productSku: valuePropositionProductSku,
              title,
              subtitle,
              description,
              descriptionList,
              iconUrl,
              imageUrl,
              objectFit,
              endLinkText,
              endLinkUrl,
              biographies,
              testimonials,
              dashUrl,
              disclaimer,
            },
            i,
          ) => {
            if (testimonials && testimonials.length) {
              return (
                <li
                  className={classNames(
                    styles.valuePropositionListItem,
                    styles.testimonial,
                  )}
                  key={`${title}_${i}`}
                >
                  <PageProductValuePropositionsTestimonials
                    valuePropositionProductSku={valuePropositionProductSku}
                    iconUrl={iconUrl}
                    testimonials={testimonials}
                    dashUrl={dashUrl}
                  />
                </li>
              );
            }
            if (biographies && biographies.length) {
              return (
                <li
                  className={classNames(
                    styles.valuePropositionListItem,
                    styles.biography,
                  )}
                  key={`${title}_${i}`}
                >
                  <PageProductValuePropositionsBiographies
                    valuePropositionProductSku={valuePropositionProductSku}
                    subtitle={subtitle}
                    iconUrl={iconUrl}
                    biographies={biographies}
                  />
                </li>
              );
            }
            if (imageUrl) {
              return (
                <li
                  className={classNames(styles.valuePropositionListItem, {
                    [styles.evenNumberedItem]: i % 2,
                  })}
                  key={`${title}_${i}`}
                >
                  <PageProductValuePropositionsItem
                    valuePropositionProductSku={valuePropositionProductSku}
                    title={title}
                    subtitle={subtitle}
                    description={description}
                    descriptionList={descriptionList}
                    iconUrl={iconUrl}
                    imageUrl={imageUrl}
                    objectFit={objectFit}
                    endLinkText={endLinkText}
                    endLinkUrl={endLinkUrl}
                    disclaimer={disclaimer}
                  />
                </li>
              );
            }
          },
        )}
      </ul>
    </section>
  );
}

export default PageProductValuePropositions;
